function Divider({className}) {
    return <hr className={`border-t-gray/30 border-t-2 ${className}`}></hr>;
}

export default Divider;
